<template>
  <div class="video-modal" v-if="show">
    <div class="video-modal-main" ref="videoModalMainRef" @click="handleClick">
      <span class="modal-close-button modal-close-icon" @click="close">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M12.121 10l3.44-3.44a1.5 1.5 0 1 0-2.121-2.12L10 7.878l-3.44-3.44A1.5 1.5 0 1 0 4.44 6.56L7.878 10l-3.44 3.44a1.5 1.5 0 1 0 2.121 2.12L10 12.122l3.44 3.44a1.495 1.495 0 0 0 2.12 0 1.5 1.5 0 0 0 0-2.122L12.12 10z"></path>
        </svg>
      </span>
      <div class="video-container">
        <video-player class="video-player vjs-custom-skin vjs-has-started video-player-container"
                      ref="videoPlayer"
                      :playsinline="true"
                      @play="onPlayerPlay($event)"
                      @pause="onPlayerPause($event)"
                      @ready="onPlayerReady"
                      :options="playerOptions">
        </video-player>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'video-modal',
  data() {
    return {
      video: null,
      show: false,
      originalOverflow: '',
      isPlay:false,
      playerOptions: {
        //播放速度
        // playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: true,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        // aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [{
          type: "video/mp4",
          src: this.src
        }],
        poster: this.poster,
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          volumePanel: {inline: false},
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        },
      },
      playIcon: 'url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2275%22%20height%3D%2275%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m0%200h75v75h-75z%22%20fill%3D%22none%22%2F%3E%3Cpath%20d%3D%22m17%2057.40318v-39.72769c0-4.05144%202.4984-6.17549%205.59106-6.17549a7.28466%207.28466%200%200%201%204.28213%201.18l33.10681%2019.07719c2.934%201.69137%204.52%203.06807%204.52%205.74281s-1.586%204.05144-4.52%205.74281l-33.10681%2019.07719a7.28466%207.28466%200%200%201%20-4.28213%201.18c-3.09266%200-5.59106-2.04539-5.59106-6.09682z%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E")',
      pauseIcon: 'url("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2275%22%20height%3D%2275%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m0%200h75v75h-75z%22%20fill%3D%22none%22%2F%3E%3Cg%20fill%3D%22%23fff%22%3E%3Crect%20height%3D%2251%22%20rx%3D%224%22%20width%3D%2216%22%20x%3D%2217%22%20y%3D%2212%22%2F%3E%3Crect%20height%3D%2251%22%20rx%3D%224%22%20width%3D%2216%22%20x%3D%2242%22%20y%3D%2212%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E")',
      playStatus: false,
      originalScrollTop: 0,
      playButtonBg: '',
    }
  },
  mounted() {

  },
  methods: {
    handleClick(event){
      // const el = this.$refs.videoModalMainRef;
      // const showClass = 'show-controls'
      // if (el) {
      //   const hasClass = el.classList.contains(showClass);
      //
      //   if (hasClass) {
      //     el.classList.remove(showClass);
      //   } else {
      //     el.classList.add(showClass);
      //     setTimeout(() => {
      //       el.classList.remove(showClass);
      //     }, 5000);
      //   }
      // }
      if (event.target === this.$refs.videoModalMainRef) {
        this.close()
      }
    },
    open(url){
      this.playerOptions.sources[0].src = url
      this.show = true;
      // this.originalScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // document.body.style.overflow = 'hidden';
    },
    close() {
      this.show = false;

      // document.body.style.overflow = ''
    },
    togglePlay() {
      const player = this.$refs.videoPlayer.player;
      if (player.paused()) {
        player.play();
      } else {
        player.pause();
      }
    },
    onPlayerPlay(event){
      this.playStatus = true
      document.documentElement.style.setProperty('--play-button-bg', this.pauseIcon);

    },
    onPlayerPause(event){
      this.playStatus = false
      document.documentElement.style.setProperty('--play-button-bg', this.playIcon);
    },
    onPlayerReady(player){
      this.$nextTick(() => {
        const playButton = player.el().querySelector('.vjs-big-play-button');
        playButton.addEventListener('click', (e) => {
          this.playStatus ? player.pause() : player.play()
        })
      })
    },
  },
  beforeDestroy() {
    document.body.style.overflow = this.originalOverflow;
  }
}
</script>

<style>
.video-modal {
  background-color: rgb(29, 29, 31);
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
.video-modal-main {
  width: 100%;
  height: 100%;
  position: relative;
}
.modal-close-button {
  width: 36px;
  height: 36px;
  display: block;
  background-color: rgb(51,51,54);
  border-radius: 50%;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}
.modal-close-button svg{
  position: absolute;
  width: 20px;
  height: 20px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  fill: rgba(255,255,255,0.8);
  transition: all .3s linear 0s;
}
.modal-close-button:hover svg{
  fill: rgba(255,255,255,1);
}

.video-modal .video-container {
  width: 1200px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.video-modal .show-controls .video-js .vjs-control-bar,
.video-modal .show-controls .video-js .vjs-big-play-button {
  opacity: 1 !important;
}

.video-modal .video-container:hover .video-play {
  opacity: 1!important;
}
.video-modal .video-container:hover .vjs-big-play-button,
.video-modal .video-container:hover .vjs-control-bar {
  opacity: 1!important;
}
.video-modal .video-container video {

}
.video-modal .vjs-custom-skin > .video-js .vjs-big-play-button {
  width: 75px!important;
  height: 75px!important;
  background-image: var(--play-button-bg);;
}
.video-modal .video-js:hover .vjs-big-play-button,
.vjs-custom-skin>.video-js .vjs-big-play-button:focus{
  background-color: rgba(0,0,0,0)!important;
}
.video-modal .vjs-has-started .vjs-big-play-button {
  display: block!important;
  opacity: 0!important;
}

.video-modal .video-js .vjs-volume-panel .vjs-volume-control{
  left: -3em!important;
  top: -6em;
}
.video-modal .vjs-slider-vertical .vjs-volume-level:before {
  left: -0.35em;
}
.video-modal .vjs-custom-skin > .video-js .vjs-volume-level {
  background-color: #ffffff;
}
.video-modal .video-js .vjs-volume-vertical {
  background-color: rgba(0,0,0,0);
}

.video-modal .vjs-custom-skin > .video-js .vjs-control:hover .vjs-volume-control {
  opacity: 1;
}
.video-modal .vjs-custom-skin > .video-js .vjs-control-bar .vjs-play-control {
  display: none!important;
}
.video-modal .video-js .vjs-control-bar {
  width: 900px;
  margin: 0 auto;
  background: rgba(0,0,0,0)!important;
  opacity: 0;
  transition: opacity .3s linear 0s;
}
.video-modal .vjs-time-divider {
  display: none!important;
}
.video-modal .video-js .vjs-duration{
  order: 3!important;
}
.video-modal .vjs-volume-bar.vjs-slider-vertical {

}
.video-modal .video-js .vjs-volume-control {

}

.video-modal .video-js .vjs-fullscreen-control .vjs-icon-placeholder:before {
  content: ''!important;
  background-image: url('data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2217%22%20height%3D%2225%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22m0%200h17v25h-17z%22%20fill%3D%22none%22%2F%3E%3Cg%20fill%3D%22%23fff%22%3E%3Cpath%20d%3D%22m9.32047%2014.0275%205.97253%205.9725h-4.793a.5.5%200%200%200%200%201h5.3999a1.10154%201.10154%200%200%200%201.1001-1.1001v-5.3999a.5.5%200%200%200%20-1%200v4.793l-5.9725-5.9725a.49995.49995%200%200%200%20-.707.707z%22%2F%3E%3Cpath%20d%3D%22m7.67953%2010.9725-5.97253-5.9725h4.793a.5.5%200%200%200%200-1h-5.3999a1.10154%201.10154%200%200%200%20-1.1001%201.1001v5.3999a.5.5%200%200%200%201%200v-4.793l5.9725%205.9725a.49995.49995%200%200%200%20.707-.707z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat;
  display: block;
  background-position: center;
}
.video-modal .video-js .vjs-fullscreen-control .vjs-icon-placeholder {

}

.video-modal .video-container .video-play {
  width: 75px;
  height: 75px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  cursor: pointer;
  opacity: 0;
  transition: opacity .3s linear 0s;
  display: block!important;
}
.video-modal .video-container .video-play img {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>